import React, { useEffect, useState } from 'react'
import Img from 'gatsby-image'

const Image = ({ source, imageStyles, styles, classes, altText, ...rest }) => {
  const [alternativeText, setAlternativeText] = useState('')

  useEffect(() => {
    if (altText) {
      setAlternativeText(altText)
    } else {
      setAlternativeText(source.description ? source.description : ``)
    }
  }, [])

  switch (true) {
    case source.hasOwnProperty('fluid'):
      return (
        <Img
          {...rest}
          className={classes}
          fluid={source.fluid}
          alt={alternativeText}
          imgStyle={imageStyles}
          style={styles}
        />
      )

    case source.childImageSharp.hasOwnProperty('fluid'):
      return (
        <Img
          {...rest}
          className={classes}
          fluid={source.childImageSharp.fluid}
          alt={alternativeText}
          imgStyle={imageStyles}
          style={styles}
        />
      )

    case source.hasOwnProperty('fixed'):
      return (
        <Img
          {...rest}
          className={classes}
          fixed={source.fixed}
          alt={alternativeText}
          imgStyle={imageStyles}
          style={styles}
        />
      )

    case source.childImageSharp.hasOwnProperty('fixed'):
      return (
        <Img
          {...rest}
          className={classes}
          fixed={source.childImageSharp.fixed}
          alt={alternativeText}
          imgStyle={imageStyles}
          style={styles}
        />
      )

    case source.hasOwnProperty('file'):
      return (
        <img
          {...rest}
          className={classes}
          src={source.file.url}
          alt={alternativeText}
          style={styles}
        />
      )

    case source.hasOwnProperty('url'):
      return (
        <img
          {...rest}
          className={classes}
          src={source.url}
          alt={alternativeText}
          style={styles}
        />
      )

    default:
      return <div></div>
  }
}

export default Image
